import { render, staticRenderFns } from "./BrowseDrill.vue?vue&type=template&id=458f867c&scoped=true&"
import script from "./BrowseDrill.vue?vue&type=script&lang=js&"
export * from "./BrowseDrill.vue?vue&type=script&lang=js&"
import style0 from "./BrowseDrill.vue?vue&type=style&index=0&id=458f867c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f867c",
  null
  
)

export default component.exports